import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import Navbar from '../Navbar';
import logo from '../../images/Limitless-BNG_WordmarkLogo.png';
import heroImg from '../../images/inside.jpg';
import skewersImg from '../../images/skewers.jpg';
import wingsImg from '../../images/wings.jpg';
import burgerImg from '../../images/burger.jpg';
import feastImg from '../../images/feast.jpg';
import lunchImg from '../../images/mf.jpg';
import dailyImg from '../../images/wwf.jpg';
import aboutImg from '../../images/kitd.jpg';
import './index.scss';

const HOURS = [
  ['Monday',    '11:30AM - 2AM'],
  ['Tuesday',   '11:30AM - 2AM'],
  ['Wednesday', '11:30AM - 2AM'],
  ['Thursday',  '11:30AM - 2AM'],
  ['Friday',    '11:30AM - 2AM'],
  ['Saturday',  '11:30AM - 2AM'],
  ['Sunday',    '11:30AM - 12AM'],
];

const FAVORITES = [
  { label: 'SKEWERS', img: skewersImg },
  { label: 'CHICKEN WINGS', img: wingsImg },
  { label: 'BURGERS', img: burgerImg },
];

class Landing2 extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="landing2">
        <Navbar />

        {/* Hero */}
        <section className="hero">
          <img src={heroImg} alt="" className="hero-img" />
          <div className="hero-overlay">
            <h1>WELCOME TO LIMITLESS BAR &amp; GRILL</h1>
            <p>Where Every Bite Takes You Beyond Limits.</p>
            <a
              href="https://squareup.com/appointments/book/irmxmolrq6ttrb/L2072RS7486MH/start"
              target="_blank"
              rel="noreferrer"
              className="btn-red"
            >
              Reserve a Table
            </a>
          </div>
        </section>

        {/* Fan's Favorites */}
        <section className="section-dark">
          <h2 className="section-title">FAN'S FAVORITES</h2>
          <div className="cards-grid">
            {FAVORITES.map(({ label, img }) => (
              <div className="promo-card" key={label}>
                <img src={img} alt={label} className="promo-card-img" />
                <p className="promo-card-label">{label}</p>
              </div>
            ))}
          </div>
          <div className="btn-center">
            <Link to="/menu" className="btn-red">View Full Menu</Link>
          </div>
        </section>

        {/* Current Promos */}
        <section className="section-dark">
          <h2 className="section-title">CURRENT PROMOS</h2>
          <div className="cards-grid">
            <div className="promo-card">
              <img src={feastImg} alt="Kamayan Feast" className="promo-card-img" />
              <p className="promo-card-label">KAMAYAN FEAST</p>
            </div>
            <Link to="/lunch-special" className="promo-card promo-card-link">
              <img src={lunchImg} alt="Lunch Special" className="promo-card-img" />
              <p className="promo-card-label">LUNCH SPECIAL</p>
            </Link>
            <Link to="/taco-tuesday" className="promo-card promo-card-link">
              <img src={dailyImg} alt="Daily Special" className="promo-card-img" />
              <p className="promo-card-label">DAILY SPECIAL</p>
            </Link>
          </div>
        </section>

        {/* About Preview */}
        <section className="section-dark about-preview">
          <div className="about-inner">
            <img src={aboutImg} alt="Drinks at Limitless Bar & Grill" className="about-img" />
            <div className="about-text">
              <p>We believe the best moments in life are limitless</p>
              <Link to="/new-about" className="btn-red">About Us</Link>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer" id="contact">
          <div className="footer-top">
            <div className="footer-col">
              <h3>Contact Us</h3>
              <p>1450 Centre St., Unit 3</p>
              <p>L4J 3N1, Thornhill, ON</p>
              <br />
              <p>T: (905) 597-5252</p>
              <p>E: limitlessbarandgrill@gmail.com</p>
            </div>
            <div className="footer-col">
              <h3>Store Hours</h3>
              {HOURS.map(([day, hrs]) => (
                <div className="hours-row" key={day}>
                  <span>{day}</span>
                  <span>{hrs}</span>
                </div>
              ))}
            </div>
            <div className="footer-col footer-logo-col">
              <img src={logo} alt="Limitless Bar & Grill" className="footer-logo" />
            </div>
          </div>
          <div className="footer-social">
            <a href="https://www.facebook.com/limitlessbng" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faFacebookSquare} size="2x" />
            </a>
            <a href="https://www.instagram.com/limitlessbng" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
          </div>
        </footer>
      </div>
    );
  }
}

export default Landing2;
